module.exports = __webpack_public_path__ + "static/media/profile-3.b6897e78.jpg";